import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.$number = this.$('number')[0];
    }

    init() {
        let number = this.generateRandom();

        if (number < 10) {
            number = '0' + number;
            this.$number.querySelector('span').innerHTML = '0' + number;
        }

        this.$number.querySelector('span').innerHTML = number;

        setInterval(() => {
            let number = this.generateRandom();

            if (number < 10) {
                number = '0' + number;
                this.$number.querySelector('span').innerHTML = '0' + number;
            }

            this.$number.querySelector('span').innerHTML = number;
        }, 1000)

        document.addEventListener('scroll', e => {
            let number = this.generateRandom();

            if (number < 10) {
                number = '0' + number;
                this.$number.querySelector('span').innerHTML = '0' + number;
            }

            this.$number.querySelector('span').innerHTML = number;
        })

    }

    generateRandom(min = 0, max = 99) {

        // find diff
        let difference = max - min;

        // generate random number 
        let rand = Math.random();

        // multiply with difference 
        rand = Math.floor(rand * difference);

        // add with min value 
        rand = rand + min;

        return rand;
    }

    destroy() {
        this.isFront = null;
    }
}
